import { Box, FormControl, MenuItem, Select, Skeleton, Tab, Tabs } from '@mui/material';
import { useState, useContext, useEffect } from 'react';
import { rqx } from '../../../../../../../core/request/API';
import { env } from '../../../../../../../core/Env';
import { Data } from './Data';
import { View } from './view/Index';
import { ToolContext } from '../../../../../../../core/context/ToolContext';

export const List = ({ prpTyp, urlParams, preview, prevLoader, history, handlerView }) => {
    const { website_state } = useContext(ToolContext);
    const { provinceData, subTypes } = website_state;
    const td = preview.data;
    const viewId = urlParams.get('view_id')
    const prop = prpTyp === "condo" ? 1: prpTyp === "commercial" ? 2: prpTyp === "apartment" ? 3 : prpTyp === "house" ? 4 : prpTyp === "land" ? 5 : 0;
    //const fltrdOTyp = ofrType === "buy" ? 1 : 2
    const [selectedLocation, setSelectedLocation] = useState('all');
    const [selectedSubType, setSelectedSubType] = useState('all');
    const tabLabels = [
        { label: 'All', url: 'all' },
        { label: 'Condominium', url: 'condo' },
        { label: 'Commercial', url: 'commercial' },
        { label: 'Apartment', url: 'apartment' },
        { label: 'House', url: 'house' },
        { label: 'Land', url: 'land' },
    ];
    //const uniqueLocations = [...new Set(td?.list?.map(p => p.location.city))];
    // const fltrd = td.list ? td.list.filter(p =>
    //     p.offer_type === fltrdOTyp &&  p.property_type === prop &&
    //     (selectedLocation === "all" || p.location.city === selectedLocation)
    // ) : [];
    const handleTabChange = (url) => {
        history.push(`/campaign/website?type=real-property&tab=${urlParams.get('tab')}&offer_type=${urlParams.get('offer_type')}&property_type=${url}`);
    };
    const getProvince = async () => {
        if (provinceData.data.value.length === 0) {
            const res_province = await rqx.get(`<<global>>/${env()}/location/province`, { ref: 'id', filter: 'all' });
            if ( res_province ) {
                provinceData.set({ ...provinceData.data, value: res_province })
            }
        }
    }
    const getSubType = async () => {
        let res = [];
        if ( prop === 0 ) {
            res = await rqx.get(`<<tool>>/${env()}/propertyListing/initialReader`, { ref: "all_property_subtype" });
        } else {
            res = await rqx.get(`<<tool>>/${env()}/propertyListing/initialReader`, { ref: "property_subtype", filtered_id: prop });
        }
        //const res_all_sub_types = await rqx.get(`<<tool>>/${env()}/propertyListing/initialReader`, { ref: "all_property_subtype" });
        //const res = await rqx.get(`<<tool>>/${env()}/propertyListing/initialReader`, { ref: "property_subtype", filtered_id: prop });
        if (res) {
            subTypes.set({ ...subTypes.data, value: res })
        }
    }
    useEffect(() => {
        getProvince();
        // eslint-disable-next-line
    }, [])
    useEffect(() => {
        getSubType();
        setSelectedSubType("all");
        // eslint-disable-next-line
    }, [prop])

    return (
        <>
            {viewId !== null ?
                !prevLoader.data && <View viewId={viewId} preview={preview} urlParams={urlParams} />
                :
                <Box width="100%" height="100%" >
                    {!prevLoader.data ? (
                        <Box width="100%" overflow="hidden" borderBottom="1px solid #ddd" position="relative" /*mt={isSmallScreen && -1.5}*/
                            // sx={{ height: isSmallScreen ? "45px" : '50px' }}
                        >
                            <Tabs variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile
                                sx={{ alignItems: 'center', position: 'sticky', top: 0, left: 0, width: '100%', backgroundColor: 'white', zIndex: 1000, '.MuiTabs-indicator': { display: 'none' }, }}
                                value={tabLabels.findIndex(tab => tab.url === prpTyp)}
                            >
                                {tabLabels.map((l, k) => (
                                    <Tab key={k} label={l.label}
                                        onClick={() => handleTabChange(l.url)}
                                        sx={{
                                            fontSize: "0.75rem",
                                            //fontSize: isSmallScreen ? '0.60rem' : '0.75rem',
                                            fontWeight: "500",
                                            //opacity: 0.9,
                                            //letterSpacing: isSmallScreen ? "0px" : "0.5px",
                                            mx: "0.25rem",
                                            p: "0.2rem 0.4rem",
                                            //height: 20,
                                            minHeight: "fit-content",  
                                            //width: isSmallScreen ? 10 : 100,
                                            border: `2px solid ${td.site_btns.bg}`,
                                            borderRadius: "8px",
                                            bgcolor: tabLabels.findIndex(tab => tab.url === prpTyp) === k ? "#fff" : td.site_btns.bg,
                                            color: tabLabels.findIndex(tab => tab.url === prpTyp) === k ? td.site_btns.bg : "#fff",
                                        }}
                                    />
                                ))}
                            </Tabs>
                        </Box>

                    ) : <Skeleton variant='rounded' width="100%" height={40} />}
                    <Box p={1} height={421} className="overflowY" pb={5}>
                        { !prevLoader.data ?
                            <>
                                <FormControl size='small' fullWidth sx={{ mb: 1 }}>
                                    <Select
                                        value={selectedSubType}
                                        onChange={(e) => setSelectedSubType(e.target.value)}
                                    >
                                        <MenuItem value="all">All Sub-Types</MenuItem>
                                        {subTypes.data.value.map((v, k) => (
                                            <MenuItem key={k} value={v.id}>{v.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl size='small' fullWidth sx={{ mb: 1 }}>
                                    <Select
                                        value={selectedLocation}
                                        onChange={(e) => setSelectedLocation(e.target.value)}
                                        MenuProps={{ PaperProps: { sx: { maxHeight: "15rem", maxWidth: "8rem" }, }, }} 
                                    >
                                        <MenuItem value="all">All Locations</MenuItem>
                                        {provinceData.data.value.map((v, k) => (
                                            <MenuItem key={k} value={v.name}>{v.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </>
                        : 
                            <Skeleton variant='rounded' width="100%" height={40} sx={{ my: 1 }} />
                        }
                        <Box mb={8} 
                            display="grid"
                            gridTemplateColumns="repeat(auto-fit, minmax(180px, 1fr))"
                            gap={2}
                        >
                            {!prevLoader.data ? (
                                td.list.length > 0 ? (
                                    td.list.map((p, k) => (
                                        <Box key={k} width="100%" display="flex" flexDirection="column" alignItems="center">
                                            <Data preview={preview} p={p} key={k} handlerView={handlerView} />
                                        </Box>
                                    ))
                                ) : (
                                    <Box width="100%" mt={2}>
                                        <Box width="100%" display="flex" alignItems="center" justifyContent="center" p={4} color="gray" border="solid 1px gray" borderRadius="8px" textAlign="center">
                                            No Data Available
                                        </Box>
                                    </Box>
                                )
                            ) : (
                                [...Array(6)].map((_, index) => (
                                    <Skeleton key={index} variant="rounded" width="100%" height={250} />
                                ))
                            )}
                        </Box>
                    </Box>
                </Box>
            }
        </>
    )
}





